import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import RestService from "./../../Restservice";
import GlobalHelmet from "./../../GlobalHelmet";
import { Link } from "react-router-dom";
import Loader from "./../../component/Loader";
import Breadcrumbs from "./../../component/breadcrumbs";
import Common from "./../../common.json";
const useStyles = makeStyles((theme) => ({
  root: {},
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
}));

export default function Index() {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [globaldata, setglobaldata] = useState(false);

  useEffect(() => {
    setLoading(true);
    RestService.getSector(function (res) {
      setLoading(false);
      const response = JSON.parse(res);
      setglobaldata(response.data.getDetails);
    });
  }, []);

  return (
    <>
      <GlobalHelmet {...Common?.sector} />
      {loading ? <Loader /> : ""}
      <div className="bodycontainer">
        <div className="auto-space">
          <div className="row">
            <div className="col-sm-12">
              <Breadcrumbs page="Sector" />

               <p>
               Get list of sectors in nse for Indian stock market. Find sector-wise stock list for nse stocks. Find stocks for different nse sectors like banking sector in india, energy sector in india, it sectors in india etc with their stock performance, pivot point analysis for stocks, 52 week high stocks, 52 week low stocks. Use nse sectors analysis for choosing the best performing sector in india. Learn how to do sector analysis? Learn  how to do stock comparison to find the best stocks from the best performing sector.
               </p>

              <div className="mt-3">
                <Grid container spacing={2}>
                  {globaldata ? (
                    globaldata.map((items) => (
                      <Grid
                        item
                        key={items.sector_id}
                        xs={6}
                        sm={4}
                        md={4}
                        lg={2}
                      >
                        <Link to={"/nse-sectors-list/" + items.slug}>
                          <Paper
                            className={"custom-grid-style " + classes.paper}
                          >
                            {" "}
                            {items.name}{" "}
                          </Paper>
                        </Link>
                      </Grid>
                    ))
                  ) : (
                    <Loader />
                  )}
                </Grid>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
